module.exports = __webpack_public_path__ + "img/ttd.41b1ecfa.png";